import FilterByColor from './FilterByColor';
export default FilterByColor;